import {
  _trim,
  _clone,
  _forin,
  _filterMapToArray,
  _applyOrdering,
} from '../utils';
import createLogger from '../../utils/createLogger';

const DEBUG = true;
const debug = createLogger(DEBUG, `jobSelectors.js`);

const postingsSelector = (state) => {
  let { postings } = state.jobs;
  return _applyOrdering(postings);
};

const leadsSelector = (state) => {
  let { leads } = state.jobs;
  return _applyOrdering(leads);
};

const createJobSelector = (id) => (state) => {
  return state.jobs.postings.records[id] || state.jobs.leads.records[id];
};

const companySelector = (state, id) => {
  return state.jobs.companiesById[id];
};

const selectActiveFilters = (state) => {
  if (state.jobs.filters) {
    let filters = _clone(state.jobs.filters);
    let activeFilters = {};

    _forin(filters, (category_id, category) => {
      let options = _filterMapToArray(category.options)
        .filter(option => option.active)
        .map(option => option.id);
      options = options.length > 0 ? options : null;

      let query = null;
      if (category.canQuery && !!category.query)
        query = category.query;

      activeFilters[category_id] = _trim({
        options,
        query,
      })

    });
    return _trim(activeFilters);
  }
  return null;
};


const selectOrderedFilters = (state) => {
  if (state.jobs.filters) {
    let filters = _clone(state.jobs.filters);
    let orderedFilters = [
      filters.source,
      filters.location,
    ];

    orderedFilters = orderedFilters.map((category) => {
      return {
        ...category,
        options: _filterMapToArray(category.options)
          .sort((a, b) => {
            return (a.order < b.order) ? -1
              : (a.order > b.order) ? 1
                : (a.id < b.id) ? -1
                  : (a.id > b.id)
                    ? 1 : 0;
          })
      };
    });

    return orderedFilters;
  }
  return null;
};


export {
  leadsSelector,
  postingsSelector,
  companySelector,
  createJobSelector,
  selectActiveFilters,
  selectOrderedFilters,
}



// WEBPACK FOOTER //
// ./src/data/jobs/jobSelectors.js